import isEmpty from 'lodash/fp/isEmpty'
import { BYPASS_SESS_KEY, COMPANY_ID_SEARCH_PARAM, DEFAULT_LOCALE, EMPTY_STRING } from 'constants/'

export function getCompanyId(): string | undefined {
  const urlParams = new URLSearchParams(window.location.search)

  return urlParams.get(COMPANY_ID_SEARCH_PARAM) || ''
}

export function isNullify(value?: string | number | null) {
  return value === '' || value === null || value === undefined
}

export function lowerCaseFirstWord(text: string) {
  if (typeof text !== 'string' || text.length === 0) {
    return text
  }

  return text.charAt(0).toLowerCase() + text.slice(1)
}

export function isCompanyIdExist(companyId?: string | null) {
  return !isEmpty(companyId) && companyId !== 'null' && companyId !== 'undefined'
}

export function setSessionStorage(key: string, value: string) {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(key, value)
  }
}

export function getSessionStorage(key: string): string | null {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem(key)
  }
  return null
}

export function setByPassFlag() {
  setSessionStorage(BYPASS_SESS_KEY, 'true')
}

export function getByPassFlag(): boolean {
  return getSessionStorage(BYPASS_SESS_KEY) === 'true'
}

const DATE_FORMAT_OPTIONS = {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
} as const

const TIME_FORMAT_OPTIONS = {
  hour: '2-digit',
  minute: '2-digit',
} as const

const DEFAULT_FORMAT_OPTIONS = { includeTime: false, locale: DEFAULT_LOCALE } as const
const INCLUDE_TIME_OPTIONS = { includeTime: true, locale: DEFAULT_LOCALE } as const

export function formatDate(
  dateValue: string,
  options: { includeTime?: boolean; locale?: string } = DEFAULT_FORMAT_OPTIONS,
) {
  if (!dateValue) return EMPTY_STRING

  const { includeTime = false, locale = DEFAULT_LOCALE } = options
  const date = new Date(dateValue)

  const formattedDate = date.toLocaleDateString(locale, DATE_FORMAT_OPTIONS)

  if (!includeTime) {
    return formattedDate
  }

  const formattedTime = date.toLocaleTimeString(locale, TIME_FORMAT_OPTIONS)

  return `${formattedDate} at ${formattedTime}`
}

export const formatDateOnly = (dateValue: string) => formatDate(dateValue, DEFAULT_FORMAT_OPTIONS)
export const formatDateWithTime = (dateValue: string) => formatDate(dateValue, INCLUDE_TIME_OPTIONS)
